import { FormTypesWithValues } from "../../types";

export const VALIDATE_ON_CHANGE_FIELD_TYPES = new Set<FormTypesWithValues>(["dateString", "date"]);
